import styled from "@emotion/styled";
import { spacing } from "@atlas-int/tokens";

/** Flex container for a dropdown menu item's content */
export const MenuItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-bottom: ${spacing[1]};
`;

/** Label with text-overflow ellipsis for dropdown items */
export const ItemLabelContainer = styled.div`
  width: 100%;
  padding-left: ${spacing[4]};
  overflow: hidden;
  padding: auto 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
